import { History } from 'history';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { MenuItem } from '../contentful/contentfulClient';
import { StoreState } from '../store/StoreState';
import { isValidLocation } from './CategoriesExtractor';
import Path = History.Path;

interface LocationValidatorStateProps {
    menuItems: Array<MenuItem>;
    dataLoaded: boolean;
}

export interface LocationValidatorProps {
    defaultLocation?: Path;
}

const LocationValidator: React.FC<LocationValidatorProps & LocationValidatorStateProps & RouteComponentProps> =
    ({history, menuItems, dataLoaded, defaultLocation = '/'}) => {
        if (dataLoaded
            && history.location.pathname !== defaultLocation
            && !isValidLocation(history.location, menuItems)) {
            history.replace(defaultLocation);
        }
        return null;
    };

function mapStateToProps(
    state: StoreState,
    ownProps: LocationValidatorProps & RouteComponentProps): LocationValidatorStateProps {
    return {
        menuItems: state.menu.menuItems,
        dataLoaded: state.menu.loaded,
        ...ownProps
    };
}

export default withRouter(connect(mapStateToProps, null)(LocationValidator));


// WEBPACK FOOTER //
// ./src/menu/LocationValidator.tsx